import { Subscription } from '@/types/core-push';
import _ from 'lodash';

export class SubUtil {

  public groupListToEntList(fullGroupIdList:string[]):Array<{entId: string, displayName:string}> {

    let retList = fullGroupIdList
      .map(groupId => ({entId: groupId.replace(/\.\w+$/, ''), displayName:''}))
      .map(item => ({entId: item.entId, displayName: item.entId.replace(/\./g, ' > ')}));
  
    retList = _.uniqBy(retList, (item => item.entId));
  
    return retList;
  }

  public filterSubs(subList:Subscription[], queryStr:string):Subscription[] {

    const tokenList = this.queryToList(queryStr);

    // if no filters let's return everything
    if(tokenList.length === 0)
      return subList.concat();

    // we apply the filters
    // enterpriseId / endpoint (JSON encoded) / type / deviceType
    return subList.filter(sub => {

      let matchCount = 0;

      for(let token of tokenList) {

        if(sub.enterpriseId.toLowerCase().includes(token))
          matchCount++;

        if(JSON.stringify(sub.endpoint).toLowerCase().includes(token))
          matchCount++;

        if(sub.type && sub.type.toLowerCase().includes(token))
          matchCount++;

        if(sub.deviceType && sub.deviceType.toLowerCase().includes(token))
          matchCount++;
        
      }
      
      return matchCount >= tokenList.length;
    })
  }

  public queryToList(queryStr:string):string[] {

    return queryStr
      .toLowerCase()
      .split(" ")
      .map(token => token.trim())
      .filter(token => token.length >= 3)
      
  }

}

